export interface ParticipatingBank {
  name: string;
  logo: string;
}

export const PARTICIPATING_BANKS: ReadonlyArray<ParticipatingBank> = [
  { name: 'BanBajío', logo: 'assets/images/banks/banbajio.png' },
  { name: 'Scotiabank', logo: 'assets/images/banks/scotiabank.png' },
  { name: 'Santander', logo: 'assets/images/banks/santander.png' },
  { name: 'INBURSA', logo: 'assets/images/banks/inbursa.png' },
  { name: 'banregio', logo: 'assets/images/banks/banregio.png' },
  { name: 'HSBC', logo: 'assets/images/banks/hsbc.png' },
  { name: 'AFIRME', logo: 'assets/images/banks/afirme.png' },
  { name: 'BanCoppel', logo: 'assets/images/banks/bancoppel.png' }
];

export const NON_PARTICIPATING_BANKS_LABEL =
  'Consulta los bancos participantes y las promociones disponibles. Bancos no participantes: Banorte, Bancomer, Banamex y AMEX.';
